import styled from 'styled-components';

export const LinkButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  text-decoration: underline;
  display: inline;
  padding: 0;
  color: #1f5099;
`;

export const Spacer = styled.div<{ $height: number }>`
  min-height: ${(p) => p.$height}px;
`;
